module.exports = __webpack_public_path__ + "img/discord.718a1ff0.svg";